import React from 'react';
import { Link } from 'react-router-dom';

import Typography from 'kingpin/atoms/Typography';
import ListItemWrapper from '../../../DatasetDefinitions/ListItemWrapper';
import Column from '../../../DatasetDefinitions/Column';
import { buildShowBoard } from '../../../../../navigation/appRoutes';
import Card from '../../../../../components/Common/Card';
import FindAndReplaceCheckbox from '../../MetricContextMenu/FindAndReplace/FindAndReplaceCheckbox';

const BoardsUsage = ({
  boards,
  usedId,
}: {
  boards: (PerformanceBoardTypes.Board | Board)[];
  usedId: string;
}) => (
  <>
    {boards.length > 0 && (
      <div style={{ marginBottom: 24 }}>
        <div style={{ marginBottom: '8px' }}>
          <Typography.Header type="H5">{`Boards (${boards.length})`}</Typography.Header>
        </div>
        <Card>
          {boards.map((b, index) => (
            <ListItemWrapper
              key={`${b.id}-${usedId}`}
              isLast={boards.length - 1 === index}
            >
              <FindAndReplaceCheckbox
                item={{ type: 'boards', board: b, itemId: b.id }}
              />
              <Column
                style={{
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                }}
              >
                <Link
                  to={buildShowBoard(b.id)}
                  target="_blank"
                  style={{ display: 'flex' }}
                >
                  <Typography.Body type="Body 12" color="var(--color-info-v2)">
                    {b.name}
                  </Typography.Body>
                </Link>
              </Column>
            </ListItemWrapper>
          ))}
        </Card>
      </div>
    )}
  </>
);

export default BoardsUsage;
